import { action, observable } from 'mobx'
import { task } from 'mobx-task'
import type { AlertErrorHandlerFactory, AlertFactory } from '@/features/shell'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import { ModalViewModel } from '@/infra/ModalViewModel'
import type { PlatformAdminWorkspaceFn } from '@/features/iam'

export class PromoteToOwnerDialogViewModel {
  readonly modal = new ModalViewModel()

  @observable
  accessor workspace: Workspace = Workspace.none

  constructor(
    private readonly _onPromoted: () => Promise<void>,
    private readonly _promoteToOwner: PlatformAdminWorkspaceFn,
    private readonly _newAlert: AlertFactory,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  @action.bound
  showForWorkspace(workspace: Workspace) {
    this.workspace = workspace
    this.modal.show()
  }

  promote = task.resolved(async () => {
    const workspaceName = this.workspace.name

    await this._promoteToOwner(this.workspace.id).catch(
      this._createAlertErrorHandler('Promoting to owner failed'),
    )

    // The promotion succeeded, so a failed refresh still reports success.
    await this._onPromoted().catch(() => undefined)

    this._newAlert()
      .withState('success')
      .saying('Success!', `You now have owner role in ${workspaceName}.`)
      .autoDismiss()
      .show()

    this.close()
  })

  @action.bound
  close() {
    this.workspace = Workspace.none
    this.modal.close()
  }
}
